import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import { makeStyles } from '@material-ui/core/styles'
import GetAppIcon from '@material-ui/icons/GetApp'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import ExcelIcon from '../../../../components/icons/ExcelIcon'
import $http from '../../../../utils/$http'
import GroupOrderFileUpload from './GroupedOrderFileUpload'
import { observer } from 'mobx-react'

const useStyles = makeStyles({
    content: {
        padding: '1em 5em'
    },
    stepContent: {
        '& li': {
            marginBottom: '1em'
        },
        marginBottom: '2em'
    },
    importantInfoContent: {
        '& li': {
            marginBottom: '0.5em'
        }
    },
    excelTemplate: {
        marginTop: '2em',
        display: 'inline-flex',
        alignItems: 'center',
    },
    excelIcon: {
        height: '32px',
    },
    filesRow: {
        marginTop: '1rem',
    },
    infoCircle: {
        width: '135px',
        height: '135px',
        borderRadius: '50%',
        fontSize: '1.2rem',
        color: '#fff',
        textAlign: 'center',
        background: '#009B48',
        textWrap: 'wrap',
        display: 'flex',
        alignSelf: 'flex-end',
        justifySelf: 'flex-end',
        justifyContent: 'center',
        alignItems: 'center',
    }
})

const NewGroupedOrder: React.FC = observer(() => {
    const { formatMessage } = useIntl();
    const classes = useStyles()
    const excelTemplateDownloadUrl = $http._getUrl('/file/group-order-excel-template')

    return (
        <Grid
            container
            justifyContent="center"
            direction="column"
            className="GridWrapper"
            style={{ marginTop: '2rem', marginBottom: '2rem' }}>
            <Grid item xs={6} style={{ padding: '1em' }}>
                <h1 className="Heading1">
                    {formatMessage({ id: 'groupOrder.idd.heading' })}
                </h1>
            </Grid>
            <Grid item xs={12} className={classes.content}>
                <p>{formatMessage({ id: 'groupOrder.description' })}</p>

                <ol className={classes.stepContent}>
                    <li>{formatMessage({ id: 'groupOrder.step1' })}</li>
                    <li>{formatMessage({ id: 'groupOrder.step2' })}</li>
                    <li>{formatMessage({ id: 'groupOrder.step3' })}</li>
                </ol>

                <h2>{formatMessage({ id: 'groupOrder.importantInfoTitle' })}</h2>
                <ul className={classes.importantInfoContent}>
                    <li>{formatMessage({ id: 'groupOrder.importantInfo1' })}</li>
                    <li>{formatMessage({ id: 'groupOrder.importantInfo2' })}</li>
                    <li>{formatMessage({ id: 'groupOrder.importantInfo3' })}</li>
                    <li>{formatMessage({ id: 'groupOrder.importantInfo4' })}</li>
                    <li>{formatMessage({ id: 'groupOrder.importantInfo5' })}</li>
                    <li>{formatMessage({ id: 'groupOrder.importantInfo6' })}</li>
                </ul>

                <Link className={classes.excelTemplate}
                    href={excelTemplateDownloadUrl}
                    download>
                    <ExcelIcon className={classes.excelIcon} />
                    {formatMessage({ id: 'groupOrder.downloadExcelTemplate' })}
                    <GetAppIcon />
                </Link>
            </Grid>
            <Grid item xs={12} className={classes.content}>
                <GroupOrderFileUpload/>
            </Grid>
        </Grid>
    )
})

export default NewGroupedOrder